import { useEffect } from 'react';
import { useUserContext } from '../../../context/UserContext';
import { useSecurityContext } from '../../../context/SecurityContext';

export default (): void => {
  const { fetchProfile } = useUserContext();
  const { accessToken, organizationId } = useSecurityContext();

  const parts = window.location.pathname.split('/');
  const type = parts[4];
  const year = parts[5];
  const index = parts[6];

  useEffect(() => {
    if (((!accessToken && !organizationId) || (accessToken && organizationId))
      && type && year && index) {
      fetchProfile(type, parseInt(year, 10), parseInt(index, 10));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, organizationId]);
};
